// extracted by mini-css-extract-plugin
module.exports = {"item-content":"language-selector-menu-item_item-content__Mg1Uw","current-language":"language-selector-menu-item_current-language__GadeI"};